var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    x: "0px",
    y: "0px",
    viewBox: "18 19 64 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Table") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70,19H30A12,12,0,0,0,18,31V69A12,12,0,0,0,30,81H70A12,12,0,0,0,82,69V31A12,12,0,0,0,70,19ZM38,73H30a4,4,0,0,1-4-4V63H38Zm0-18H26V45H38Zm0-18H26V31a4,4,0,0,1,4-4h8ZM74,69a4,4,0,0,1-4,4H46V63H74Zm0-14H46V45H74Zm0-18H46V27H70a4,4,0,0,1,4,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTable);
export default __webpack_public_path__ + "static/media/icon-table.d160fe1841410a8769ba51765a029447.svg";
export { ForwardRef as ReactComponent };